import { Plus, MessageSquare, X } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { useAiChatStore } from '../model/aiChatStore';
import type { AiChatSummary } from '../api/ai';
import styles from './ChatHistory.module.css';
import { Scroller } from '@/shared/ui';

interface ChatHistoryProps {
  onOpen: (chatId: string) => void;
  onNew: () => void;
  onClose: () => void;
}

function chatLabel(c: AiChatSummary): string {
  if (c.title) return c.title;
  const d = new Date(c.updatedAt);
  return `Чат от ${d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}`;
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({ onOpen, onNew, onClose }) => {
  const chats = useAiChatStore((s) => s.chats);
  const loading = useAiChatStore((s) => s.loadingChats);
  const currentChatId = useAiChatStore((s) => s.chatId);

  return (
    <aside className={styles.panel}>
      <header className={styles.header}>
        <span className={styles.title}>История</span>
        <button className={styles.iconBtn} aria-label="Закрыть историю" onClick={onClose}>
          <X size={16} />
        </button>
      </header>

      <button className={styles.newChat} onClick={onNew}>
        <Plus size={16} /> Новый чат
      </button>

      <Scroller className={styles.list} viewportClassName={styles.listViewport}>
        {loading && <div className={styles.empty}>Загрузка…</div>}
        {!loading && chats.length === 0 && <div className={styles.empty}>Чатов пока нет</div>}
        {chats.map((c) => (
          <button
            key={c.id}
            className={cn(styles.item, c.id === currentChatId && styles.active)}
            onClick={() => onOpen(c.id)}
          >
            <MessageSquare size={14} className={styles.itemIcon} />
            <span className={styles.itemLabel}>{chatLabel(c)}</span>
            {c.status === 'archived' && <span className={styles.badge}>архив</span>}
          </button>
        ))}
      </Scroller>
    </aside>
  );
};
